<template>
  <dialog class="VideoDialog" @close="markClosed">
    <div class="closeButtonShelf">
      <CloseButton @click="close" class="closeButton" />
    </div>
    <div class="navButtonsShelf">
      <button @click="activatePrevVideo" class="navButton">
        <span v-html="caretLeftSvg" class="caretIcon"></span>
        <span>{{ localeStrings.previousVideo }}</span>
      </button>
      <button @click="activateNextVideo" class="navButton">
        <span>{{ localeStrings.nextVideo }}</span>
        <span v-html="caretRightSvg" class="caretIcon"></span>
      </button>
    </div>
    <div v-if="isOpen && videos[activeVideoIndex]">
      <SanityVideo :videoFile="videos[activeVideoIndex].videoFile" autoplay controls class="video" />
    </div>
  </dialog>
</template>

<script>
import strings from './strings.json'

import CloseButton from '~/vue-components/shared/CloseButton.vue'

const caretRightSvg = `
  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M2,2 L8,8 L2,14" fill="none" stroke="currentColor" stroke-width="2.5" />
  </svg>
`

const caretLeftSvg = `
  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8,2 L2,8 L8,14" fill="none" stroke="currentColor" stroke-width="2.5" />
  </svg>
`

export default {
  components: {
    CloseButton,
  },
  props: {
    videos: Array,
    activeVideoIndex: Number,
    activateNextVideo: Function,
    activatePrevVideo: Function,
  },
  inject: ['locale'],
  data() {
    return {
      caretLeftSvg,
      caretRightSvg,
      isOpen: false,
    };
  },
  computed: {
    localeStrings() {
      return strings[this.locale];
    },
  },
  methods: {
    // NOTE: The showVideo() method is called by the parent component
    showVideo() {
      this.$el.showModal();
      this.isOpen = true;
    },
    markClosed() {
      this.isOpen = false;
    },
    close() {
      this.$el.close();
    },
  },
}
</script>

<style scoped>
/* Reset styles */
dialog {
  border-style: none;
  padding: 0;
  background-color: transparent;
}

.VideoDialog {
  max-width: 95%;
}

.VideoDialog::backdrop {
  background-color: rgba(0, 0, 0, 0.75);
}

.closeButtonShelf {
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-2);
}

.closeButton {
  --main-color: var(--text-color-white);
}

.navButtonsShelf {
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-2);
}

.navButton {
  display: flex;
  align-items: center;
  column-gap: var(--spacing-3);
  font-size: var(--font-size-3);
  color: var(--text-color-white);
}

.navButton:focus,
.closeButton:focus {
  color: #ddd;
  outline: none;
}

.video {
  width: 100%;
  max-width: 60rem;
  max-height: 60rem;
}
</style>
